import { PureComponent } from "react";
import { PINGDOM } from "/constants/marketing-keys";
const PINGDOM_SCRIPT_URL = "//rum-static.pingdom.net/prum.min.js";

export default class PingdomScript extends PureComponent {
  pingdomScriptGenerator() {
    return `var _prum = [['id', '${PINGDOM}'],
       ['mark', 'firstbyte', (new Date()).getTime()]];
        (function() {
            var s = document.getElementsByTagName('script')[0]
              , p = document.createElement('script');
            p.async = 'async';
            p.src = '${PINGDOM_SCRIPT_URL}';
            s.parentNode.insertBefore(p, s);
        })();`;
  }
  render() {
    return (
      <script
        dangerouslySetInnerHTML={{
          __html: this.pingdomScriptGenerator()
        }}
      />
    );
  }
}
